import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function InsForm7YT() {
    return (
        <React.Fragment>
            <Typography sx={{ pt: 3, fontSize: '2rem', }}>2　説明・確認事項</Typography>
            <Grid container direction='row' sx={{ pt: 1.5, pb: 1.5, pl: 5, alignItem: "center" }} >
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>各種取扱方法</Typography>
                <Grid container direction='column' sx={{ pt: 1, pb: 1.5, pl: 3, }} >
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>1) 外部建具のメンテナンス</Typography>

                    <Grid container direction='column' sx={{ pt: 1.5, pb: 1, pl: 4, }} >
                        <Typography sx={{ pl: 2, pt: 0.5, pb: 0.5, fontSize: '1.5rem', }}>① 玄関ドアの調整方法</Typography>
                        <Typography sx={{ pl: 2, pt: 1.5, pb: 0.5, fontSize: '1.5rem', }}>② 外部建具のチェック方法</Typography>
                        <Grid container direction='column' sx={{ pt: 0.5, pb: 1.5, pl: 3.5, }} >
                            <Typography sx={{ pl: 2, pb: 0.5, fontSize: '1.5rem', }}>1. パッキンの劣化</Typography>
                            <Typography sx={{ pl: 2, pb: 0.5, fontSize: '1.5rem', }}>2. 障子の組子部の隙間</Typography>
                            <Typography sx={{ pl: 2, pb: 0.5, fontSize: '1.5rem', }}>3. ドアの下がり</Typography>
                            <Typography sx={{ pl: 2, pb: 0.5, fontSize: '1.5rem', }}>4. 金具の劣化、注油</Typography>
                        </Grid>
                    </Grid>

                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>2) フローリングのお手入れについて；床材に合わせたお手入れ方法</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>3) 網戸のお手入れについて</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>4) 24時間換気システムのお手入れ及び、メンテナンス(定期交換部品)</Typography>

                    <Grid container direction='column' sx={{ pt: 1.5, pb: 1, pl: 4, }} >
                        <Typography sx={{ pl: 2, pt: 0.5, pb: 0.5, fontSize: '1.5rem', }}>鍋物等を行う場合の換気方法、注意点(特にエアコンのスライム)の説明</Typography>
                    </Grid>

                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>5) トイレ、洗面、キッチン換気扇のお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>6) 排水トラップ(浴室、洗濯機等)のお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>7) 「住まいの手びき」確認</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>8) 準防火地域において”防火ダンパー付外部給排気口”設置の場合、ヒューズ切れの定期的な点検について</Typography>

                </Grid>
            </Grid>
            <Grid container direction='row' sx={{ pt: 1.5, pb: 1.5, pl: 5, alignItem: "center" }} >
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>長期優良住宅にお住まいの方</Typography>

                <Grid container direction='column' sx={{ pt: 1, pb: 1.5, pl: 3, }} >
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>長期優良住宅は、法律に基づいた定期点検記録を保管する必要があります。</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>行政庁等より報告を求められた時には、この点検記録をご提出ください。</Typography>
                </Grid>
            </Grid>

            <Typography sx={{ pt: 3, fontSize: '2rem', }}>７年目以降のお手入れ推奨部位とチェックポイント</Typography>

            <Grid container direction='row' sx={{ pt: 1.5, pb: 1.5, pl: 3.5, alignItem: "center" }} >
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>1 外部建具</Typography>
                <Grid container direction='column' sx={{ pt: 1, pl: 1, }} >
                    <Typography sx={{ pl: 2, pb: 2, fontSize: '1.5rem', }}>・再塗装の検討　・シーリングの劣化確認と再施工の検討</Typography>
                </Grid>
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>2 木製バルコニー</Typography>
                <Grid container direction='column' sx={{ pt: 1, pl: 1, }} >
                    <Typography sx={{ pl: 2, pb: 2, fontSize: '1.5rem', }}>・再塗装の検討　・木部の劣化状況の確認　；・カビ、褐色腐朽菌の発生と腐食の有無　・割れ等</Typography>
                </Grid>
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>3 防水バルコニー</Typography>
                <Grid container direction='column' sx={{ pt: 1, pl: 1, }} >
                    <Typography sx={{ pl: 2, pb: 2, fontSize: '1.5rem', }}>・トップコート（仕上げ材）の劣化の確認　・ＦＲＰの劣化確認；排水口廻り、立上り部分</Typography>
                </Grid>
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>4 屋根葺材</Typography>
                <Grid container direction='column' sx={{ pt: 1, pl: 1, }} >
                    <Typography sx={{ pl: 2, pb: 2, fontSize: '1.5rem', }}>・苔、カビの発生有無の確認</Typography>
                </Grid>
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>5 ユニットバスシーリング</Typography>
                <Grid container direction='column' sx={{ pt: 1, pl: 1, }} >
                    <Typography sx={{ pl: 2, pb: 2, fontSize: '1.5rem', }}>・床、壁、窓廻りのシーリング劣化の確認　；シーリングは７～10年が再施工の目安</Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
